import { usePutAssetMutation } from '../../features/api/apiSlice';
import React, { useEffect, useRef, useState } from 'react';
import useClickOutside from '../../utils/useClickOutside';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

export default function AddNote({
  isModalOpen,
  setModalOpen,
  selectedAsset,
  setSelectedAsset,
  refetch,
}) {
  const modalRef = useRef();
  const [note, setNote] = useState(selectedAsset?.note || '');
  const [updateAsset] = usePutAssetMutation();

  useClickOutside(modalRef, '', () => setModalOpen(false));

  const handleSubmit = async () => {
    if (!selectedAsset) return;

    await updateAsset({
      projectId: selectedAsset.project_id,
      assetId: selectedAsset.id,
      note: note,
    });
    if (typeof refetch === 'function') refetch();

    setSelectedAsset(null);
    setModalOpen(false);
  };

  const headerTemplate = () => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '1.2rem',
        marginBottom: '1rem',
      }}
    >
      <span style={{ fontWeight: 'bold' }}>
        {selectedAsset?.note ? 'Edit note for asset' : 'Add note to asset'}
        <span style={{ fontWeight: 'bolder', marginLeft: '0.3rem' }}>{selectedAsset.name}</span>
      </span>
    </div>
  );

  const footerTemplate = () => (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-outlined p-button-danger"
        onClick={() => setModalOpen(false)}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-outlined p-button-primary"
        onClick={handleSubmit}
      />
    </div>
  );

  if (!isModalOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        ref={modalRef}
        style={{
          backgroundColor: '#fff',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '500px',
          maxWidth: '90%',
        }}
      >
        {headerTemplate()}
        <InputText
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Your note.."
          style={{ width: '100%' }}
        />
        {footerTemplate()}
      </div>
    </div>
  );
}
